import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-semantic-yes',
  templateUrl: './semantic-yes.component.html',
  styleUrls: ['./semantic-yes.component.css'],
})
export class SemanticYesComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: { choice: string; other: string };
  }>();

  selectedValue: string | null = null;
  opinionText: string = '';

  handleSelection(answerUuid: string, hasInput: boolean): void {
    this.selectedValue = answerUuid;

    if (!hasInput) {
      this.opinionText = '';
    }

    this.emitAnswer();
  }

  emitAnswer(): void {
    this.answerSelected.emit({
      questionUuid: this.question.uuid,
      answerValue: {
        choice: this.selectedValue!,
        other: this.opinionText || '',
      },
    });
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
